var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"products-display"},[_c('Title',{attrs:{"title":_vm.title}}),_c('ProductsLayout',{attrs:{"forceDisplayProducts":_vm.displayedProducts,"forceLoading":_vm.isLoading,"prefix":_vm.prefix,"featuredProducts":true,"isCarousel":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }